import React from 'react';
import PropTypes from 'prop-types';

const HeaderInfoSection = ({
  dateOfService,
  mrn,
  physician,
  patientName,
  physicianSpeciality,
  department,
  payer,
  accountNumber,
  facility,
  dob,
  gender,
  encounterId,
  auditedBy,
  auditedOn,
  finalizedBy,
  finalizedOn,
  onHoldInfo
}) => {
  return (
    <div>
      <table>
        <tbody>
          <tr>
            <td style={{ width: '33%' }}>
              <div>
                DOS: {dateOfService}
              </div>
              <div>
                Physician: {physician}
              </div>
              <div>
                Payer: {payer}
              </div>
              <div>
                Dob: {dob}
              </div>
            </td>
            <td style={{ width: '33%' }}>
              <div>
                MRN: {mrn}
              </div>
              <div>
                Specialty: {physicianSpeciality}
              </div>
              <div>
                Account: {accountNumber}
              </div>
              <div>
                Gender: {gender}
              </div>
            </td>
            <td>
              <div>
                Patient Name: {patientName}
              </div>
              <div>
                Department: {department}
              </div>
              <div>
                Facility: {facility}
              </div>
              <div>
                Encounter ID: {encounterId}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      { (finalizedOn !== null && finalizedOn !== "") &&
        <div>
          <span>Finalized by <strong>{finalizedBy}</strong> on <strong>{finalizedOn}</strong>.</span>
        </div>
      }
      { (auditedOn !== null && auditedOn !== "") &&
        <div>
          <span>Audited by <strong>{auditedBy}</strong> on <strong>{auditedOn}</strong>.</span>
        </div>
      }
      {
        (onHoldInfo !== null && onHoldInfo !== "") &&
        <div>
          <span>On Hold by <strong>{onHoldInfo}</strong></span>
        </div>
      }
    </div>
  );
};

HeaderInfoSection.propTypes = {
  dateOfService: PropTypes.string,
  mrn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  physician: PropTypes.string,
  patientName: PropTypes.string,
  physicianSpeciality: PropTypes.string,
  department: PropTypes.string,
  payer: PropTypes.string,
  accountNumber: PropTypes.string,
  facility: PropTypes.string,
  dob: PropTypes.string,
  gender: PropTypes.string,
  encounterId: PropTypes.string,
  auditedBy: PropTypes.string,
  auditedOn: PropTypes.string,
  finalizedBy: PropTypes.string,
  finalizedOn: PropTypes.string
};

export default HeaderInfoSection;
